import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Injectable()
export class PageService {

  title : string = ""
  addDevice : boolean = false;
  addPlant : boolean = false;
  addMaintenanceReminder : boolean = false;
  addButton : boolean = true;
  breadCrumb : boolean = false;
  showVideo : boolean = false;

  myInstallation: boolean = false;
  agenda : boolean = false;
  settings : boolean = false;

  lastVisit : string = "";
  private _ascending : boolean = true;

  constructor(public router : Router,
    private snackBar : MatSnackBar) {}

  set ascending(value:boolean){
    this._ascending = value;
  }

  get ascending() : boolean{
    return this._ascending;
  }

  setTitle(name : string){
    this.title = name;
  }

  setLastVisit(path: string) {
    this.lastVisit = path;
  }

  setDeviceButton(value : boolean) {
    this.addDevice = value;
  }

  setPlantButton(value : boolean) {
    this.addPlant = value;
  }

  setMaintenanceReminderButton(value : boolean) {
    this.addMaintenanceReminder = value;
  }

  setAddButton(value : boolean){
    this.addButton = value;
  }

  setBreadCrumb(value : boolean){
    this.breadCrumb = value;
  }

  navigateTo(path : string){
    this.router.navigateByUrl(path);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
      panelClass: ['success-snackbar']
    });
  }

  openErrorSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['error-snackbar']
    });
  }

}
